import * as React from 'react';
import { Search } from 'lucide-react';

import { cn } from '@/lib/utils';
// Relative (not `@/components/...`): when this file is consumed by an app's
// Vitest, the `@/` alias resolves to the *app's* src, so an aliased sibling
// import fails to resolve. A relative path is correct in both contexts.
import { Input } from '../input/input';

export type SearchInputProps = React.ComponentProps<'input'>;

/**
 * Input with a leading search icon. Composes the base {@link Input} so it shares
 * the exact shadcn control styling — `border-input` boundary, `bg-background`
 * fill, and the standard focus ring — adding only the leading icon and its left
 * padding. `className` sizes the wrapper (e.g. `w-80`), mirroring how a bare
 * Input's width is set by consumers.
 */
const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, type = 'search', ...props }, ref) => (
    <div className={cn('relative', className)}>
      <Search
        aria-hidden
        className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
      />
      <Input
        type={type}
        ref={ref}
        className="pl-9 [&::-webkit-search-cancel-button]:appearance-none"
        {...props}
      />
    </div>
  ),
);
SearchInput.displayName = 'SearchInput';

export { SearchInput };
